import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import {
    FORM_CONTENT_UPDATE_PERMISSION,
    FORM_DELETE_PERMISSION,
    FORM_ITEM_CREATE_PERMISSION,
    FORM_ITEM_WRITE_PERMISSION,
    FORM_READ_PERMISSION,
    FORM_SAVE_PERMISSION,
    FORM_UPDATE_PERMISSION,
} from "./permissions";

const FORM_PERMISSIONS = {
    read: FORM_READ_PERMISSION,
    update: FORM_UPDATE_PERMISSION,
    delete: FORM_DELETE_PERMISSION,
    content: FORM_CONTENT_UPDATE_PERMISSION,
    item: FORM_ITEM_CREATE_PERMISSION,
    save: FORM_SAVE_PERMISSION,
    itemWrite: FORM_ITEM_WRITE_PERMISSION,
};

const FormAccessControl = ({ children, action = "update" }) => (
    <ComponentAccessControl baseResources={FORM_PERMISSIONS[action]}>
        {children}
    </ComponentAccessControl>
);

export default FormAccessControl;
